module.exports = __webpack_public_path__ + "media/images/Results-Cohort1_2_LowChance-763ac1c2b94c48945231d387dbd84f8b.png";